/**
 * Generiert eine stabile, eindeutige ID.
 * Primaer: crypto.randomUUID() (verfuegbar in modernen Browsern + Node 19+)
 * Fallback: Timestamp + Random String
 */
export function generateId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 11)}`;
}
